import { decode } from "io-ts-promise";
import { SiteJobKind, siteJobKindT, siteJobT, siteJobsT } from "dora-contracts";

/**
 * /api/site-jobs. The shapes themselves live in `dora-contracts`
 * (`contracts/src/equipment.ts`), the contract both sides decode against,
 * so this module only names the decoders and the kind list the UI needs.
 */
export type {
  SiteJob,
  SiteJobOrder,
  SiteJobPlace,
  // Body of POST /api/site-jobs.
  CreateSiteJob,
  // A site job covers the same two kinds of work as a single-unit job.
  SiteJobKind,
} from "dora-contracts";

/**
 * The kinds as a list, for the dropdown. `dora-contracts` exports the codec
 * but no values array beside it, so the list is read off the codec rather
 * than written out a second time and left to drift from it.
 */
export const siteJobKindValues: SiteJobKind[] = siteJobKindT.types.map(
  (c) => c.value
);

export const decodeSiteJob = decode(siteJobT);
export const decodeSiteJobs = decode(siteJobsT);
